import type { InventoryVehicle } from '@carvana/merch-contracts';
import {
  useEffectWithController,
  useLoadableState
} from '@carvana/merch-react-hooks';
import { useUserLocation } from '~/context/common/UserContext';
import fetchSuggestedVehicles from '~/services/common/fetchSuggestedVehicles';
import { generateErrorLogger } from '~/utilities/loggers';

type ReturnType = {
  hasError: boolean;
  isLoaded: boolean;
  vehicles: Array<InventoryVehicle>;
};

export default function useGetSrpSuggestedForYou(): ReturnType {
  const { zip } = useUserLocation();
  const {
    data: vehicles,
    hasError,
    isLoaded,
    setData,
    setError,
    setLoaded,
    setLoading
  } = useLoadableState<Array<InventoryVehicle>>([]);

  useEffectWithController(
    controller => {
      if (!zip) {
        setLoaded();

        return;
      }

      setLoading();

      fetchSuggestedVehicles({ zipCode: zip }, controller)
        .then(setData)
        .catch(
          generateErrorLogger(
            'Suggested For You (SRP)',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoaded, setLoading, zip]
  );

  return { hasError, isLoaded, vehicles };
}
